module.exports = __webpack_public_path__ + "2-55.jpg?089572474877332164d1387783169b29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-55.jpg
// module id = 132
// module chunks = 0